new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

fixAccessibility();

function fixAccessibility() {
    const element = document.querySelector('#boost-cart-app');
    if (element) {
        element.setAttribute('role', 'region');
        element.setAttribute('aria-label', 'Shopping cart');
    }
}